export default "__VITE_ASSET__B2n93xyk__"